import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";

import Stage from "../../../../../components/Stage";
import ButtonBack from "../../../../../components/Buttons/Back";
import InputText from "../../../../../components/Inputs/Text";
import InputSelect from "../../../../../components/Inputs/Select";
import InputTextArea from "../../../../../components/Inputs/TextArea";
import InputCheckBox from "../../../../../components/Inputs/Checkbox";
import { TratoComponent } from "../../../../../components/Form/Trato";
import ReactLoading from "react-loading";

import { getOnlyAudiCenters, scrollToInput } from "../../../../../utilities/utils";
import ROUTES from "../../../../../utilities/Routes";

import {
    setTratamientoAction,
    setNombreAction,
    setMovilAction,
    setCorreoAction,
    setEstadoAction,
    setCiudadAction,
    setIdConcesionarioAction,
    setConcesionarioAction,
    setComentariosAction,
    setAvisosDePrivacidadAction,
    setTerminosCondicionesAction,
    setTransferenciaDeDatosAction,
    setContactoMarketingAction,
    reiniciarStateAction
} from "../../../../../actions/audiCampaignActions";

import {
    getEstados,
    getConcesionarios,
} from "../../../../../API/CitasServicioRequest/index";

import {
    getCiudades,
} from "../../../../../API/ConfiguradorRequest/index";

import {
    isOnlyNumbers,
} from "../../../../../utilities/Validations";
import { sendMailDucattiCampaignCliente, sendMailDucattiCampaignConcesionaria } from "../../../../../API/CampaignRequest";
import { validarCelular, validarCorreo, validarNombre } from "../../../../../utilities/Validations/lead";
//import { sendLeadToSaas } from "../../../../../API/SaasRequest";
import SeoPixel from "../../../../../plugins/seo";

const FormCampaignDucatti = () => {
    const dispatch = useDispatch();
    const objSubmit = useSelector((state) => state.campaign);
    let navigate = useNavigate();

    const setTratamiento = (inNombre) => {
        dispatch(setTratamientoAction(inNombre));
    };
    const setNombre = (inNombre) => {
        dispatch(setNombreAction(inNombre));
    };
    const setMovil = (inMovil) => {
        dispatch(setMovilAction(isOnlyNumbers(inMovil)));
    };
    const setCorreo = (inCorreo) => {
        dispatch(setCorreoAction(inCorreo));
    };
    const setEstado = (inEstado) => {
        dispatch(setEstadoAction(inEstado));
    };
    const setCiudad = (inCiudad) => {
        dispatch(setCiudadAction(inCiudad));
    };
    const setIdConcesionario = (inIdConcesionario) => {
        dispatch(setIdConcesionarioAction(inIdConcesionario));
    };
    const setConcesionario = (inConcesionario) => {
        dispatch(setConcesionarioAction(inConcesionario));
    };
    const setComentarios = (inComentarios) => {
        dispatch(setComentariosAction(inComentarios));
    };
    const setAvisosDePrivacidad = (inAvisosDePrivacidad) => {
        dispatch(setAvisosDePrivacidadAction(inAvisosDePrivacidad));
    };
    const setTerminosCondiciones = (inTerminosCondiciones) => {
        dispatch(setTerminosCondicionesAction(inTerminosCondiciones));
    };
    const setTransferenciaDeDatos = (inAvisosDePrivacidad) => {
        dispatch(setTransferenciaDeDatosAction(inAvisosDePrivacidad));
    };
    const setContactoMarketing = (inTerminosCondiciones) => {
        dispatch(setContactoMarketingAction(inTerminosCondiciones));
    };

    const [estados, setEstados] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [concesionarios, setConcesionarios] = useState([]);

    const [showErrorEstado, setErrorEstado] = useState(false);
    const [showErrorCiudad, setErrorCiudad] = useState(false);
    const [showErrorConcesionario, setErrorConcesionario] = useState(false);
    const [showErrorDeclaraciones, setErrorDeclaraciones] = useState(false);

    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [showErrorSubmit, setShowErrorSubmit] = useState(false);

    const filterCiudades = useMemo(() => {
        if (estados.length > 0 && ciudades.length > 0) {
            const estadoSelected = estados.find(
                (edo) => edo.nombreedo === objSubmit.provincia
            );

            if (estadoSelected === undefined) return [];

            return ciudades.filter(
                (cd) => cd.idestado.idestado === estadoSelected.idestado
            );
        }
        return [];
    }, [objSubmit, estados, ciudades]);

    const filterConcesionarios = useMemo(() => {
        if (concesionarios.length > 0 && estados.length > 0) {
            const estadoSelected = estados.find(
                (edo) => edo.nombreedo === objSubmit.provincia
            );

            if (estadoSelected === undefined) return [];

            return concesionarios.filter(
                (concesionario) => concesionario.stateName === estadoSelected.nombreedo
            );
        }
        return [];
    }, [objSubmit.provincia, estados, concesionarios]);

    useEffect(() => {
        const funGetEstado = async () => {
            getEstados().then((responseEstados) => {
                setEstados(responseEstados.data);
            });
        };
        const funGetCiudades = async () => {
            getCiudades().then((responseCiudades) => {
                setCiudades(responseCiudades.data);
            });
        };

        const funGetConcesionarios = async () => {
            getConcesionarios().then((responseConcesionarios) => {
                const filterConcesionarios = getOnlyAudiCenters(responseConcesionarios.data.data);
                setConcesionarios(filterConcesionarios);
            });
        };

        funGetEstado();
        funGetCiudades();
        funGetConcesionarios();
    }, [])


    useEffect(() => {

        if (process.env.REACT_APP_ENABLE_GA4 === "true") {
            // Se inicializa el objeto de analytics para el sitio
            ReactGA.initialize(process.env.REACT_APP_CAMPAIGN_GA_ID);
        }
    }, []);

    const onSubmit = (e) => {
        e.preventDefault();

        const dataIsvalid = validateForm();

        if (dataIsvalid) {
            setLoadingSubmit(true);
            setShowErrorSubmit(false);
            const lead = { ...objSubmit }

            lead.numeroConcesionaria = objSubmit.numeroConcesionaria < 1000
                ? "0" + objSubmit.numeroConcesionaria
                : "" + objSubmit.numeroConcesionaria

            delete lead.avisoPrivacidad
            delete lead.terminosCondiciones
            delete lead.nombreDelVehiculo

            const contactos = getContactosConcesionaria(objSubmit.numeroConcesionaria);

            lead.descripcion = lead.descripcion.trim() === "" ? "Sin comentarios" : lead.descripcion.trim();
            lead.descripcion = "Cross Selling Ducati - " + (lead.descripcion.trim() === "" ? "Sin comentarios" : lead.descripcion.trim());

            sendMailDucattiCampaignCliente(lead)
                .then(() => {
                    sendMailDucattiCampaignConcesionaria({ ...lead, contactos })
                    setLoadingSubmit(false);
                    reiniciarStateAction();
                    //handleSendLeadToSaas(lead, '', true, "Formulario Campaña Ducati", '');

                    navigate(ROUTES.CAMPAIGNDUCATITHANKYOUEMPTY);
                })
                .catch((error) => {
                    setLoadingSubmit(false);
                    setShowErrorSubmit(true);
                    console.log("ERROR: ", error);
                });
        }
    }

    /*const handleSendLeadToSaas = (lead, idTransaccion, status, model, message) => {
        sendLeadToSaas(lead, process.env.REACT_APP_FORM_ID_AUDI_NUEVO, idTransaccion, status, model, message)
            .then(respuesta => {
                // manejar respuesta
            })
            .catch(error => {
                // manejar error
                console.error("Error en log: " + error)
            });
    }*/

    const getContactosConcesionaria = (numeroConcesionaria) => {
        const dealerInfo = concesionarios.find(
            (dealer) => dealer.dealerNumber === numeroConcesionaria
        );

        if (dealerInfo.contactos === null) return []

        let contactos =
            dealerInfo.contactos.split(",").length > 8
                ? dealerInfo.contactos
                    .split(",")[9]
                    .split(";")
                    .map((item) => item.trim())
                : "";
        return contactos
    }

    const validateForm = () => {
        if (validarNombre(objSubmit.nombre) === false) {
            scrollToInput("nombre", "Por favor ingresa un nombre válido");
            return false
        }
        if (validarCelular(objSubmit.celular) === false) {
            scrollToInput("movil", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCorreo(objSubmit.email) === false) {
            scrollToInput("correo", "Por favor ingresa un valor válido");
            return false;
        }
        if (objSubmit.provincia === "") {
            scrollToInput("estado");
            setErrorEstado(true);
            return false;
        } else {
            setErrorEstado(false);
        }
        if (objSubmit.ciudad === "") {
            scrollToInput("ciudad");
            setErrorCiudad(true);
            return false;
        } else {
            setErrorCiudad(false);
        }
        if (objSubmit.numeroConcesionaria === "" || objSubmit.concesionariaPreferida === "") {
            scrollToInput("concesionario");
            setErrorConcesionario(true);
            return false;
        } else {
            setErrorConcesionario(false);
        }

        if (
            objSubmit.avisoPrivacidad === false ||
            objSubmit.terminosCondiciones === false ||
            objSubmit.permisoTransferenciaDatos === false ||
            objSubmit.permisoContactoMarketing === false
        ) {
            setErrorDeclaraciones(true);
            return false;
        } else {
            setErrorDeclaraciones(false);
        }

        return true
    }

    return (
        <>
            <SeoPixel
                title_form="Tu próximo Audi te espera"
                description="Cross Selling Ducati"
                keywords="audi,contacto,formulario,campaña,ducati"
                image={process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/form_ducati_home.png"}
                url={process.env.REACT_APP_DOMAIN + ROUTES.CAMPAIGNDUCATI.substring(0, ROUTES.CAMPAIGNDUCATI.length - 1)}
            />
            <main className="audi-nuevo">
                <Stage title="Tu próximo Audi te espera" img={process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/form_ducati_home.png"} />
                <div className="button-back-container">
                    <ButtonBack />
                </div>
                <section className="container w-100 pt-3">
                    <p className="mb-3">
                        Por favor completa el siguiente formulario. Nos pondremos en contacto contigo para resolver tus dudas y brindarte la información que necesitas sobre tu Audi.
                    </p>
                    <form className="w-100 pt-5" onSubmit={onSubmit}>
                        <TratoComponent value={objSubmit.tratamiento} onChange={(e) => { setTratamiento(e.target.value) }} />
                        <h3>Datos de contacto</h3>
                        <div className="w-100 d-flex flex-column flex-md-row gap-5 mt-4 mb-5">

                            <div className="w-100 w-md-50 d-flex flex-column gap-5">
                                <InputText
                                    label="¿Cuál es tu nombre?"
                                    name="nombre"
                                    maxLength={40}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        e.target.value = value;
                                        setNombre(value);
                                    }}
                                    validator={validarNombre}
                                    errorMessage={objSubmit.nombre.length > 40 ? "Máx. 40 cáracteres" : "Carácter no válido, por favor usa solo letras."}
                                />
                                <InputText
                                    label="¿Cuál es tu número de teléfono móvil?"
                                    name="movil"
                                    maxLength={10}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 10) {
                                            setMovil(e.target.value);
                                        }
                                    }}
                                    errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                    validator={validarCelular}
                                />
                                <InputText
                                    label="¿Cuál es tu e-mail?"
                                    name="correo"
                                    maxLength={80}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 80)
                                            setCorreo(e.target.value);
                                    }}
                                    errorMessage="Por favor usa un e-mail válido con formato: nombre@dominio.com"
                                    validator={validarCorreo}
                                />
                            </div>
                            <div className="w-100 w-md-50 d-flex flex-column gap-5">
                                <InputSelect
                                    label="Estado"
                                    name="estado"
                                    options={estados.map((item, i) => ({
                                        value: item.nombreedo,
                                        label: item.nombreedo,
                                    }))}
                                    onChange={(e) => {
                                        setEstado(e.target.value);
                                    }}
                                    errorMessage="Selecciona una opción"
                                    showError={showErrorEstado}
                                    defaultValue={objSubmit.provincia}
                                />
                                <InputSelect
                                    label="Ciudad"
                                    name="ciudad"
                                    options={filterCiudades.map((item, i) => ({
                                        value: item.nombrecd,
                                        label: item.nombrecd,
                                    }))}
                                    onChange={(e) => {
                                        setCiudad(e.target.value);
                                    }}
                                    disabled={objSubmit.provincia === ""}
                                    showError={showErrorCiudad}
                                    errorMessage="Selecciona una opción"
                                    defaultValue={objSubmit.ciudad}
                                />
                            </div>
                        </div>
                        <h3 className="pt-5">Información de interés</h3>
                        <div className="w-100 d-flex flex-column flex-md-row gap-5 mt-4 mb-5">
                            <div className="w-100 w-md-50 d-flex flex-column gap-5">
                                <InputSelect
                                    label="Concesionario"
                                    name="concesionario"
                                    options={filterConcesionarios.map((item, i) => ({
                                        value: item.dealerNumber,
                                        label: item.name,
                                    }))}
                                    onChange={(e) => {
                                        const concesionario = concesionarios.find(
                                            (con) => con.dealerNumber === parseInt(e.target.value)
                                        );

                                        setIdConcesionario(concesionario.dealerNumber);
                                        setConcesionario(concesionario.name);
                                    }}
                                    showError={showErrorConcesionario}
                                    noDataMessage={objSubmit.provincia === "" ? "Para seleccionar el concesionario, por favor, primero selecciona tu estado" : "No hay concesionarios, por favor, selecciona otro estado."}
                                    showNoDataMessage={objSubmit.provincia !== ""}
                                    errorMessage="Selecciona una opción"
                                    defaultValue={objSubmit.numeroConcesionaria}
                                />
                            </div>

                            <div className="w-100 w-md-50 d-flex flex-column gap-5">
                            </div>

                        </div>
                        <div>
                            <InputTextArea
                                name="comentarios"
                                placeholder="Escribe aquí las dudas o información que te gustaría conocer."
                                errorMessage="Tu comentario excede los 1,000 caracteres"
                                maxLength={1000}
                                onChange={(e) => {
                                    setComentarios(e.target.value);
                                }}
                                isValid={true}
                            />
                        </div>
                        <div className="mt-5 pt-5">
                            <h3 >Estamos comprometidos con tu privacidad</h3>
                            <p className="mt-4 pb-5">
                                En Audi usamos la información que nos proporcionas para ofrecerte contenido de valor sobre los productos y servicios con los que contamos. Permítenos brindarte una mejor experiencia, a través de un contacto personalizado al aceptar los siguientes avisos:
                            </p>

                            <div className="d-flex flex-column gap-3">
                                <b>
                                    <InputCheckBox
                                        rounded
                                        label="Aceptar todo"
                                        onChange={(e) => {

                                            var checkboxes =
                                                document.getElementsByName("checkboxgroup");

                                            checkboxes.forEach((cbx) => {
                                                cbx.checked = e.target.checked;
                                            });
                                            setAvisosDePrivacidad(e.target.checked);
                                            setTerminosCondiciones(e.target.checked);
                                            setTransferenciaDeDatos(e.target.checked);
                                            setContactoMarketing(e.target.checked);
                                        }}
                                    />
                                </b>

                                <InputCheckBox
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setAvisosDePrivacidad(e.target.checked);
                                    }}
                                >
                                    <span>
                                        He leído y acepto el{" "}
                                        <a
                                            href="https://www.audi.com.mx/es/tools/navigation/layer/legal/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Aviso de Privacidad.
                                        </a>
                                    </span>
                                </InputCheckBox>
                                <InputCheckBox
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setTerminosCondiciones(e.target.checked);
                                    }}
                                >
                                    <span>
                                        He leído y acepto el{" "}
                                        <a
                                            href="https://www.audi.com.mx/es/tools/navigation/layer/terminos_y_condiciones/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Términos y Condiciones.
                                        </a>
                                    </span>
                                </InputCheckBox>
                                <InputCheckBox
                                    label="Acepto que los datos aquí proporcionados sean transferidos al Concesionario marca Audi que he elegido, para dar seguimiento a mi solicitud."
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setTransferenciaDeDatos(e.target.checked);
                                    }}
                                />
                                <InputCheckBox
                                    label="Acepto que los datos aquí proporcionados sean transferidos a Facebook Mexico S. de R.L. de C.V., Twitter, Inc. y Google Operaciones de México, S. de R.L. de C.V., para efectos de marketing."
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setContactoMarketing(e.target.checked);
                                    }}
                                />

                                <span
                                    className={`inValid-input ${showErrorDeclaraciones ? "" : "d-none"
                                        }`}
                                >
                                    Para continuar, acepta nuestras declaraciones de conformidad.
                                </span>

                            </div>

                        </div>
                        <div>
                            {!loadingSubmit ? (
                                <button className={`button-enviar`} type="submit">
                                    Enviar
                                </button>
                            ) : (
                                <button
                                    className="button-enviar disabled"
                                    type="button"
                                    disabled={true}
                                >
                                    <div className="loading-g loading-send loading-btn">
                                        <div>
                                            <ReactLoading
                                                type="cylon"
                                                color="#fff"
                                                width={"100%"}
                                                height={"58px"}
                                            />
                                        </div>
                                    </div>
                                </button>
                            )}
                        </div>
                        <span
                            className={`mb-5 inValid-input d-block ${!showErrorSubmit ? "d-none" : ""
                                }`}
                        >
                            Hubo un error. Por favor, Intentelo más tarde.
                        </span>
                    </form>
                </section>
            </main>
        </>
    );
};

export default FormCampaignDucatti;